<template>
  <header class="header-container" :style="`background-color:${showBg ? '#262E44' : 'transparent'}`">
    <div class="header-core">
      <div class="logo">
        <router-link to="/" class="logo-link space-between">
          <img src="../../assets/home/whiteLogo.png" alt="钒星" />
          <span>钒星北斗开放平台</span>
        </router-link>
      </div>
      <div class="navbar" role="navigation">
        <div class="navbar-collapse collapse">
          <ul class="nav navbar-nav">
            <li class="nav-li">
              <div class="nav-item-title">
                <router-link to="/" class="nav-item link-nav-item">首页</router-link>
                <!-- <a class="nav-item link-nav-item" target="" href="/advantage">首页</a> -->
              </div>
            </li>
            <li class="nav-li">
              <div class="nav-item-title">
                <span class="nav-item">产品介绍</span>
              </div>

              <div class="nav-sub-box">
                <span class="arrow"></span>
                <ul class="nav-sub">
                  <li class="nav-sub-li">
                    <strong>
                      <span class="nav-sub-li-title">芯片</span>
                    </strong>

                    <ul class="nav-third third-line">
                      <li class="nav-third-li">
                        <router-link class="nav-third-item" to="/product/voicechip">
                          <span class="nav-third-item-title">低码率声码器芯片</span>
                        </router-link>
                      </li>
                    </ul>
                  </li>

                  <li class="nav-sub-li">
                    <strong>
                      <span class="nav-sub-li-title">压缩算法</span>
                    </strong>

                    <ul class="nav-third third-line">
                      <li class="nav-third-li">
                        <router-link class="nav-third-item" to="/product/compress">
                          <span class="nav-third-item-title">低码率语音压缩算法</span>
                        </router-link>
                      </li>

                      <li class="nav-third-li">
                        <router-link class="nav-third-item" to="/product/pic">
                          <span class="nav-third-item-title">渐进式图像压缩算法</span>
                        </router-link>
                      </li>
                    </ul>
                  </li>

                  <li class="nav-sub-li">
                    <strong>
                      <span class="nav-sub-li-title">PC端软件</span>
                    </strong>

                    <ul class="nav-third third-line">
                      <li class="nav-third-li">
                        <router-link class="nav-third-item" to="/pc/bdtest">
                          <span class="nav-third-item-title">北斗三号测试软件</span>
                        </router-link>
                      </li>
                      <li class="nav-third-li">
                        <router-link class="nav-third-item" to="/pc/bdsystem">
                          <span class="nav-third-item-title">北斗三号指挥系统</span>
                        </router-link>
                      </li>
                      <li class="nav-third-li">
                        <router-link class="nav-third-item" to="/pc/bdsystemPro">
                          <span class="nav-third-item-title">星地多网融合调度平台</span>
                        </router-link>
                      </li>
                    </ul>
                  </li>

                  <li class="nav-sub-li">
                    <strong>
                      <span class="nav-sub-li-title">平台&服务</span>
                    </strong>

                    <ul class="nav-third third-line">
                      <li class="nav-third-li">
                        <router-link class="nav-third-item" to="/product/sdk">
                          <span class="nav-third-item-title">北斗SDK产品</span>
                        </router-link>
                      </li>

                      <li class="nav-third-li">
                        <router-link class="nav-third-item" to="/product/applyCard">
                          <span class="nav-third-item-title">北斗卡申请服务</span>
                        </router-link>
                      </li>

                      <li class="nav-third-li">
                        <router-link class="nav-third-item" to="/product/operate">
                          <span class="nav-third-item-title">北斗运营服务平台</span>
                        </router-link>
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
            </li>

            <li class="nav-li">
              <div class="nav-item-title">
                <span class="nav-item">解决方案</span>
              </div>

              <div class="nav-sub-box">
                <span class="arrow"></span>
                <ul class="nav-sub">
                  <li class="nav-sub-li">
                    <ul class="nav-third">
                      <li class="nav-third-li">
                        <router-link class="nav-third-item" to="/solution/voice">
                          <span class="nav-third-item-title">北斗应急语音对讲系统</span>
                        </router-link>
                      </li>

                      <li class="nav-third-li">
                        <router-link class="nav-third-item" to="/solution/custom">
                          <span class="nav-third-item-title">企事业单位定制北斗应用</span>
                        </router-link>
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
            </li>

            <li class="nav-li">
              <div class="nav-item-title">
                <span class="nav-item">开发支持</span>
              </div>

              <div class="nav-sub-box">
                <span class="arrow"></span>
                <ul class="nav-subTool">
                  <li class="nav-sub-li">
                    <div class="space-between nav-sub-li-strong">
                      <div>
                        <span class="iconCSS iconfont icon-pc-copy"></span>
                        <span class="nav-sub-li-title">PC端</span>
                      </div>
                      <span class="iconCSS2 iconfont icon-you"
                        v-if="docsData.pcDocs && docsData.pcDocs.length > 0"></span>
                    </div>
                    <ul class="nav-third third-line">
                      <li class="nav-third-li" v-for="item in docsData.pcDocs" :key="item.fileId">
                        <router-link class="nav-third-item" :to="`/pc/web/${item.nameEn}`">
                          <span class="">{{ item.name }}</span>
                        </router-link>
                      </li>
                    </ul>
                  </li>

                  <li class="nav-sub-li">
                    <div class="space-between nav-sub-li-strong">
                      <div>
                        <span class="iconCSS iconfont icon-anzhuo"></span>
                        <span class="nav-sub-li-title">Android平台</span>
                      </div>
                      <span class="iconCSS2 iconfont icon-you"
                        v-if="docsData.androidDocs && docsData.androidDocs.length > 0"></span>


                      <ul class="nav-third third-line">
                        <li class="nav-third-li" v-for="item in docsData.androidDocs" :key="item.fileId">
                          <router-link class="nav-third-item" :to="`/api/Android/${item.nameEn}`">
                            <span class="">{{ item.name }}</span>
                          </router-link>
                        </li>
                      </ul>
                    </div>
                  </li>

                  <li class="nav-sub-li">
                    <div class="space-between nav-sub-li-strong">
                      <div>
                        <span class="iconCSS iconfont icon-pingguo"></span>
                        <span class="nav-sub-li-title">iOS平台</span>
                      </div>
                      <span class="iconCSS2 iconfont icon-you"
                        v-if="docsData.iosDocs && docsData.iosDocs.length > 0"></span>

                      <ul class="nav-third third-line">
                        <li class="nav-third-li" v-for="item in docsData.iosDocs" :key="item.fileId">
                          <router-link class="nav-third-item" :to="`/api/IOS/${item.nameEn}`">
                            <span class="">{{ item.name }}</span>
                          </router-link>
                        </li>
                      </ul>
                    </div>
                  </li>

                  <li class="nav-sub-li">
                    <div class="space-between nav-sub-li-strong">
                      <div>
                        <span class="iconCSS iconfont icon-html5"></span>
                        <span class="nav-sub-li-title">Web服务</span>
                      </div>
                      <span class="iconCSS2 iconfont icon-you"
                        v-if="docsData.smDocs && docsData.smDocs.length > 0"></span>
                    </div>

                    <ul class="nav-third third-line">
                      <li class="nav-third-li" v-for="item in docsData.smDocs" :key="item.fileId">
                        <router-link class="nav-third-item" :to="`/api/web/${item.nameEn}`">
                          <span class="">{{ item.name }}</span>
                        </router-link>
                      </li>
                    </ul>
                  </li>

                  <li class="nav-sub-li">
                    <div class="space-between nav-sub-li-strong">
                      <div>
                        <span class="iconCSS iconfont icon-zhibozhong"></span>
                        <router-link class="nav-sub-li-title" :to="`/pc/protocolParsingTool`">
                          在线协议解析工具
                        </router-link>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </li>

            <li class="nav-li">
              <div class="nav-item-title">
                <router-link class="nav-item link-nav-item" to="/about">关于我们</router-link>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <div class="user">
        <div v-if="token" class="has-login btn-wrapper">
          <a :href="`${baseConsoleLink}`" target="_blank" class="login btn">控制台</a>
          <el-dropdown class="account" placement="top-end" :show-timeout="100" :hide-timeout="200">
            <div class="avatar">
              <!-- 设置默认头像 -->
              <Avatar class="defaultAvatar" v-if="!userInfo.avatar" :username="`${getUserNameAvatar}`"
                backgroundColor="#3f51b5" :lighten="60" color="#fff" :size="30"></Avatar>

              <!-- 用户自己设置过头像 -->
              <div v-else class="avatar-wrapper">
                <img :src="`${baseUrl}/api/console/files/pic/${userInfo.avatar}`" alt="avatar" />
              </div>

              <!-- 未读消息大于0标记有未读消息-->
              <span v-if="unReadCount > 0" class="dot"></span>
            </div>
            <el-dropdown-menu slot="dropdown" class="dropdown-menu">
              <el-dropdown-item>
                <div class="userInfo space-between">
                  <span class="username">{{ userInfo.nickname || userInfo.account }}</span>
                  <span class="logout" @click="handleLogout">退出</span>
                </div>
              </el-dropdown-item>
              <el-dropdown-item>
                <a :href="`${baseConsoleLink}/#/systemMessage/messageBox`" class="message-info flex-start"
                  target="_blank">
                  <span>我的消息</span>
                  <span v-if="unReadCount" class="badge">{{ unReadCount }}</span>
                </a>
              </el-dropdown-item>
              <el-dropdown-item>
                <a class="application" :href="`${baseConsoleLink}/#/application/myApp`" target="_blank">应用管理</a>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>

        <div v-else class="has-login btn-wrapper">
          <span class="login" @click="openLogin">登录</span>
          <button class="register" @click="openRegister">注册</button>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import Avatar from 'vue-avatar';
import config from '@/config';
import event from '@/utils/event';
export default {
  data() {
    return {
      baseUrl: config.baseUrl,
      baseConsoleLink: config.baseConsoleLink,
    };
  },
  computed: {
    ...mapState(['showBg', 'docsData', 'token', 'userInfo', 'unReadCount']),
    getUserNameAvatar() {
      let accountName = this.userInfo && this.userInfo.account;
      return (this.userInfo && this.userInfo.nickname) || accountName;
    },
  },
  methods: {
    ...mapActions(['setBg', 'logout']),
    debounce(func, wait, immediate) {
      let timeout;
      return function () {
        let context = this,
          args = arguments;
        const later = function () {
          timeout = null;
          if (!immediate) func.apply(context, args);
        };
        const callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
      };
    },
    handleScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollTop > 48) {
        // this.showBg = true;
        this.setBg(true);
      } else {
        // console.log(this.$route.meta.name);
        if (this.$route.meta.name == 'docs') {
          this.setBg(true);
        } else {
          this.setBg(false);
        }
      }
    },
    handleLogout() {
      this.logout();
    },
    openRegister() {
      event.$emit('openRegister');
    },
    openLogin() {
      event.$emit('openLogin');
    },
  },
  components: {
    Avatar,
  },
  mounted() {
    window.addEventListener('scroll', this.debounce(this.handleScroll, 10, false));
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.debounce(this.handleScroll, 10, false));
  },
};
</script>

<style lang="scss" scoped>
.flex-start {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}

.space-between {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.header-container {
  position: fixed;
  height: 48px;
  width: 100%;
  z-index: 200;
  top: 0;

  // background-color: transparent;
  .header-core {
    width: 1200px;
    margin: 0 auto;
    height: 48px;
    line-height: 48px;

    .logo {
      float: left;
      height: 48px;
      margin-right: 24px;

      .logo-link {
        height: 48px;

        img {
          max-width: 36px;
          margin-right: 10px;
        }

        span {
          color: #fff;
          font-size: 14px;
          font-weight: 600;
        }
      }

      a {
        text-decoration: none;
      }
    }

    .navbar {
      height: 48px;
      float: left;
      padding-right: 100px;

      .navbar-collapse {
        float: left;
        opacity: 1;

        .nav {
          margin: 0;
          float: left;

          .nav-li {
            float: left;
            text-align: center;
            margin: 0 45px;
            white-space: nowrap;
            position: relative;

            a {
              text-decoration: none;
            }

            .nav-item-title {
              position: relative;
              font-size: 14px;

              .nav-item {
                color: #fff;
              }
            }

            .nav-sub-box {
              max-height: 0;
              position: absolute;
              opacity: 1;
              left: 50%;
              top: 48px;
              transform: translate(-50%);
              border-top: 0 solid #fff;
              box-shadow: none;
              overflow: hidden;
              margin-top: -6px;
              box-shadow: 0 0 7px 0 rgb(0 0 0 / 19%);

              .arrow {
                width: 0;
                height: 0;
                border: 6px solid transparent;
                border-bottom-color: #fff;
                z-index: 3;
                left: 50%;
                top: 0;
                margin-left: -6px;
                margin-top: -6px;
                position: absolute;
              }

              .nav-sub {
                background: #fff;
                margin-top: 6px;
                position: relative;
                bottom: 0;

                .nav-sub-li {
                  text-align: center;
                  padding: 15px 10px;
                  width: 180px;
                  display: inline-block;
                  vertical-align: top;

                  strong {
                    color: rgba(0, 0, 0, 0.85);
                    line-height: 40px;
                    font-size: 14px;
                    cursor: default;
                    font-weight: 500;
                    // display: block;
                    padding-left: 10px;
                    padding-right: 10px;
                    margin-bottom: 10px;
                    border-bottom: 1px solid #ebebeb;
                    position: relative;

                    .nav-sub-li-title {
                      display: inline-block;
                      color: #080a25;
                      // padding: 0 10px;
                      position: relative;
                      font-size: 14px;
                      font-weight: 400;
                    }
                  }

                  .nav-third {
                    .nav-third-li {
                      min-width: 170px;
                      text-align: center;
                      height: 30px;
                      line-height: 30px;
                      font-weight: 400;
                      font-size: 12px;

                      .nav-third-item {
                        display: inline-block;
                        width: 100%;
                        height: 100%;

                        span {
                          color: #000;
                          padding: 0 10px;
                        }
                      }

                      &:hover {
                        .nav-third-item {
                          background-color: #e4edff;
                        }
                      }
                    }
                  }

                  &:first-child {
                    padding-left: 20px;
                  }

                  &:last-child {
                    padding-right: 20px;
                  }
                }

                &::before {
                  content: '';
                  width: 0;
                  height: 0;
                  border: 6px solid transparent;
                  border-bottom-color: #fff;
                  z-index: 3;
                  left: 50%;
                  margin: -12px 0 0 -6px;
                  position: absolute;
                }
              }

              .nav-subTool {
                background: #fff;
                margin-top: 6px;
                position: relative;
                bottom: 0;

                .nav-sub-li {
                  text-align: left;
                  // padding: 15px 10px;
                  padding-left: 10px;
                  width: 180px;
                  // display: inline-block;
                  vertical-align: top;

                  .iconCSS {
                    margin-right: 10px;
                  }

                  .iconCSS2 {
                    font-size: 14px;
                    color: #ccc;
                  }

                  .nav-sub-li-strong {
                    color: rgba(0, 0, 0, 0.85);
                    line-height: 40px;
                    font-size: 14px;
                    cursor: default;
                    font-weight: 500;
                    padding-left: 10px;
                    padding-right: 10px;
                    margin-bottom: 10px;
                    border-bottom: 1px solid #ebebeb;
                    position: relative;

                    .nav-sub-li-title {
                      display: inline-block;
                      color: #080a25;
                      // padding: 0 10px;
                      position: relative;
                      font-size: 14px;
                      font-weight: 400;

                      .no-color {
                        color: #080a25;
                        /* 或者直接设置为想要的颜色值 */
                      }
                    }

                    &:hover {
                      .nav-third {
                        display: block !important;
                      }
                    }
                  }

                  .nav-third {
                    display: none;
                    background: #fff;
                    position: absolute;
                    right: -95%;
                    top: 0;
                    // display: none;

                    .nav-third-li {
                      min-width: 170px;
                      text-align: center;
                      height: 30px;
                      line-height: 30px;
                      font-weight: 400;
                      font-size: 12px;

                      .nav-third-item {
                        display: inline-block;
                        width: 100%;
                        height: 100%;

                        span {
                          color: #000;
                          padding: 0 10px;
                        }
                      }

                      &:hover {
                        .nav-third-item {
                          background-color: #e4edff;
                        }
                      }
                    }
                  }

                  &:hover {
                    background-color: #e4edff;
                  }

                  // &:first-child {
                  //   padding-left: 20px;
                  // }

                  // &:last-child {
                  //   padding-right: 20px;
                  // }
                }

                &::before {
                  content: '';
                  width: 0;
                  height: 0;
                  border: 6px solid transparent;
                  border-bottom-color: #fff;
                  z-index: 3;
                  left: 50%;
                  margin: -12px 0 0 -6px;
                  position: absolute;
                }
              }
            }

            &:hover {
              .nav-sub-box {
                overflow: visible;
              }
            }
          }
        }
      }
    }

    .user {
      float: right;

      .btn-wrapper {
        font-size: 14px;
        color: #fff;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;

        button {
          font-size: 14px;
          padding: 5px 15px;
          font-weight: 400;
          border: none;
          color: #fff;
          border-radius: 2px;
          // margin-left: 20px;
          cursor: pointer;
        }

        a {
          text-decoration: none;
        }

        .login {
          color: #fff;
          margin-right: 10px;
          line-height: 48px;
          display: inline-block;
          padding: 0px 15px;
          cursor: pointer;
        }

        .register {
          background: linear-gradient(219deg, #788bf9, #1f92f9, #349cc8);
        }

        .avatar {
          width: 32px;
          height: 48px;
          position: relative;

          .avatar-wrapper {
            width: 30px;
            height: 30px;
            border-radius: 50%;
            border: 1px solid rgba(255, 255, 255, 0.08);
            overflow: hidden;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);

            img {
              max-width: 100%;
            }
          }

          .defaultAvatar {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
          }

          .dot {
            width: 5px;
            height: 5px;
            border-radius: 50%;
            position: absolute;
            top: 10px;
            right: 0;
            background-color: #eb3a44;
          }
        }
      }
    }
  }

  &:hover {
    // cursor: pointer;
    background-color: #262e44 !important;
  }
}
</style>